module.exports = __webpack_public_path__ + "img/13.cd1aa26e.png";